const DELIMITER = ',';

export const queryStringToArrayNumber = (queryString: string): number[] =>
  (queryString?.length && queryString.split(DELIMITER).map(Number)) || [];

export const arrayToQueryString = (array: number[] | string[]): string => array.join(DELIMITER);

export const queryStringToBoolean = (queryString: string): boolean => queryString === 'true';
